export namespace Security {

  export function sanitizeHTML(strHtml: string) {
    return strHtml.replace(/[^\w. ]/gi, (c) => '&#' + c.charCodeAt(0) + ';');
  }

}
